import { createFileRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { useTranslations } from 'use-intl';
import { ErrorState } from '@leanin/ui';
import { RetryButton } from '@/components/states/index';
import { moderationKeys } from '@/lib/queries/moderation';
import { ContestStatusView } from './-components/ContestStatusView';

export const Route = createFileRoute(
  '/_authed/moderation/contest/$contestationId/',
)({
  component: ContestStatusPage,
});

function ContestStatusPage() {
  const t = useTranslations('Moderation');
  const { contestationId } = Route.useParams();
  const query = useQuery({
    ...moderationKeys.myContestation(contestationId),
    retry: false,
  });

  if (query.isLoading) return null;
  if (query.isError) {
    const status = (query.error as { status?: number })?.status;
    const isNotFound = status === 404;
    return (
      <ErrorState
        title={t('errors.contestNotFoundTitle')}
        body={
          isNotFound
            ? t('errors.contestNotFoundBody')
            : t('errors.contestGenericBody')
        }
        reference={isNotFound ? 'http_404' : 'http_500'}
        {...(isNotFound ? {} : { primary: <RetryButton /> })}
      />
    );
  }
  return <ContestStatusView contestationId={contestationId} />;
}
